import { Button, Heading, VStack } from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const NotFoundPage = () => {
  const navigate = useNavigate()
  return (
    <VStack h="100vh" w="100vw" role="alert" justifyContent="center" alignItems="center" spacing="20px">
      <Heading size="lg">Page Not Found</Heading>
      <Button colorScheme="blue" onClick={() => navigate('/auth/login')}>
        Go to Login Page
      </Button>
    </VStack>
  )
}

export default NotFoundPage
